import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Backspace(): React.ReactElement {
  return (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.8295 0H5.59852C5.13658 0 4.70364 0.200189 4.41048 0.550278L0.115352 5.68361C-0.0384507 5.8677 -0.0384507 6.13234 0.115352 6.31642L4.41101 11.4502C4.70364 11.7998 5.13662 12 5.59852 12H14.8295C15.6755 12 16.3636 11.3271 16.3636 10.5V1.50004C16.3636 0.672865 15.6755 0 14.8295 0ZM12.4845 7.793L11.0383 9.20706L9.20457 7.4141L7.37086 9.20706L5.92466 7.793L7.75837 6.00004L5.92466 4.20708L7.37086 2.79301L9.20457 4.58597L11.0383 2.79301L12.4845 4.20708L10.6508 6.00004C10.6507 6.00004 12.4845 7.793 12.4845 7.793Z" />
    </svg>
  );
}
